import { datadogLogs } from '@datadog/browser-logs';

export function initBrowserLogger(serviceName: string, environment: string) {
  datadogLogs.init({
    clientToken: 'pub52101d5c6d212f06f9cdb2c6da217332',
    env: environment,
    forwardErrorsToLogs: true,
    sampleRate: 100,
    service: serviceName,
    site: 'datadoghq.com',
  });
}

export const logger = datadogLogs.logger;
